export default __webpack_public_path__ + "static/media/xp-user.e9963897.svg";